import Modal from "@/components/modal"
import Button from "@/components/button"
import Link from "@/components/link"
import EstablishmentSiteImage from "@/entities/establishment/ui/EstablishmentSiteImage"
import EstablishmentSiteImageUpload from "@/entities/establishment/ui/EstablishmentSiteImageUpload"
import { useAppSelector } from "@/core/root-reducer"
import establishmentStore from "@/entities/establishment/model/establishment.store"
import { MapOverviewArea } from "@/entities/map/model/map.types"
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"

interface Props {
  onClose: () => void
}

export default function EstablishmentOverviewEditModal({ onClose }: Props) {
  const [draftAreas, setDraftAreas] = useState<Record<string, MapOverviewArea | null>>({})
  const [editAction, setEditAction] = useState<"validate" | null>(null)
  const [selectedMapId, setSelectedMapId] = useState<string | null>(null)
  const [isReplacingImage, setIsReplacingImage] = useState(false)
  const [imageKey, setImageKey] = useState(0)
  const establishment = useAppSelector(establishmentStore.selectors.active)
  const hasChanges = Object.keys(draftAreas).length > 0
  const canDeleteSelection = Boolean(selectedMapId && draftAreas[selectedMapId] !== null)

  return (
    <Modal
      title="Modifier la vue d'ensemble"
      isFullscreen
      disableClickOutside
      disableOverflow
      className="overview-edit-modal"
      footer={
        <div className="flex items-center gap-10">
          {establishment.siteImageUploaded && <Link onClick={() => setIsReplacingImage(true)}>Remplacer l’image</Link>}
          <Button isWithBorder onClick={onClose}>
            Fermer
          </Button>
          {canDeleteSelection && (
            <Button
              icon={faTrashAlt}
              className="warning"
              onClick={() => setDraftAreas((current) => ({ ...current, [selectedMapId!]: null }))}>
              Supprimer le positionnement
            </Button>
          )}
          {selectedMapId && hasChanges && (
            <Button className="primary" onClick={() => setEditAction("validate")}>
              Valider
            </Button>
          )}
        </div>
      }>
      <div className="flex h-full min-h-0 py-10">
        <EstablishmentSiteImage
          key={imageKey}
          draftAreas={draftAreas}
          setDraftAreas={setDraftAreas}
          editAction={editAction}
          onEditActionHandled={() => setEditAction(null)}
          onSaved={() => setSelectedMapId(null)}
          setSelectedMapId={setSelectedMapId}
        />
      </div>

      {isReplacingImage && (
        <Modal title="Remplacer l'image" onClose={() => setIsReplacingImage(false)}>
          <EstablishmentSiteImageUpload
            onUploaded={() => {
              setImageKey(Date.now())
              setIsReplacingImage(false)
            }}
          />
        </Modal>
      )}
    </Modal>
  )
}
